module.exports = __webpack_public_path__ + "static/ebook_cover04-eb7f209c797e9d7a6fda96e2b544cdd6.jpg";